import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import Flow from 'flow';
import { createSession } from 'flow/actions/chat-actions';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'flow/utils/router-utils';
import { routes } from 'flow/types/routes';
import CallAdaptiveButton from 'flow/components/CallAdaptiveButton';
import MailToWrapper from 'flow/components/custom-components/MailToWrapper';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import VideoCallButton from 'flow/components/VideoCallButton';
import useAppContext from 'flow/hooks/useAppContext';
import useFeatureFlags, { FeatureFlags } from 'flow/hooks/useFeatureFlags';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectChatSessionByChatUser } from 'flow/selectors/chat-selectors';
import { selectOwnExtensionKey, selectOwnUserHasCapabilityVideo, selectOwnUserHasCapabilityVideo1on1 } from 'flow/selectors/ExtensionSelectors';
import { addChatLogEntry } from 'flow/utils/browser-utils';
import { getCallableNumberFromContact } from 'flow/utils/extension-utils';
import { addMeetingLog } from 'flow/utils/meeting-utils';
import { twMerge } from 'tailwind-merge';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SquareButtonsContainer = function SquareButtonsContainer(props) {
  var handleTogglePresenceNotification = props.handleTogglePresenceNotification,
    shouldNotifyPresence = props.shouldNotifyPresence,
    allowPresenceNotification = props.allowPresenceNotification,
    emailAdress = props.emailAdress,
    contact = props.contact,
    extensionKey = props.extensionKey,
    className = props.className,
    _props$disableVideoCa = props.disableVideoCall,
    disableVideoCall = _props$disableVideoCa === void 0 ? false : _props$disableVideoCa,
    _props$disableMessagi = props.disableMessaging,
    disableMessaging = _props$disableMessagi === void 0 ? false : _props$disableMessagi;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var history = useHistory();
  var ownUserHasVideoCapability = useAppSelector(selectOwnUserHasCapabilityVideo);
  var ownUserHasVideo1on1Capability = useAppSelector(selectOwnUserHasCapabilityVideo1on1);
  var ownExtensionKey = useAppSelector(selectOwnExtensionKey);
  var chatUserKey = useAppSelector(function (state) {
    return state.extensions.getIn(['extensions', extensionKey, 'chatUserKey']);
  });
  var chatSessionKey = useAppSelector(function (state) {
    return selectChatSessionByChatUser(state, chatUserKey, ownExtensionKey);
  });
  var _useFeatureFlags = useFeatureFlags(),
    hasFeature = _useFeatureFlags.hasFeature;
  var navigateToLobby = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newChatSessionKey, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!chatSessionKey) {
              _context.next = 1;
              break;
            }
            history.push(generatePath(routes['messages.id.lobby'], {
              id: chatSessionKey
            }));
            _context.next = 4;
            break;
          case 1:
            _context.prev = 1;
            _context.next = 2;
            return dispatch(createSession(chatUserKey));
          case 2:
            newChatSessionKey = _context.sent;
            history.push(generatePath(routes['messages.id.lobby'], {
              id: newChatSessionKey
            }));
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            addMeetingLog('Failed to create chat session for meeting lobby redirect', _t);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function navigateToLobby() {
      return _ref.apply(this, arguments);
    };
  }();
  var navigateToChat = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var newChatSessionKey, _t2;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!chatSessionKey) {
              _context2.next = 1;
              break;
            }
            history.push(generatePath(routes['messages.id'], {
              id: chatSessionKey
            }));
            _context2.next = 4;
            break;
          case 1:
            _context2.prev = 1;
            _context2.next = 2;
            return dispatch(createSession(chatUserKey));
          case 2:
            newChatSessionKey = _context2.sent;
            history.push(generatePath(routes['messages.id'], {
              id: newChatSessionKey
            }));
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t2 = _context2["catch"](1);
            addChatLogEntry('Failed to create chat session', _t2);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function navigateToChat() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleChatInteraction = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ev) {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            ev.stopPropagation();
            _context3.next = 1;
            return navigateToChat();
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleChatInteraction(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleMeetingInteraction = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ev) {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            ev.stopPropagation();
            _context4.next = 1;
            return navigateToLobby();
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleMeetingInteraction(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var VideoButton = function VideoButton() {
    if (!chatUserKey || disableVideoCall || !ownUserHasVideoCapability && !ownUserHasVideo1on1Capability) {
      return null;
    }
    if (hasFeature(FeatureFlags.VIDEO_CANVAS) && !!extensionKey && ownUserHasVideo1on1Capability) {
      return /*#__PURE__*/_jsx(VideoCallButton, {
        extensionKey: extensionKey,
        chatSessionKey: chatSessionKey
      });
    }
    return /*#__PURE__*/_jsx(IconButton, {
      className: "size-10 rounded-sm bg-gray-200",
      onClick: handleMeetingInteraction,
      tooltipLabel: i18next.t('Tooltip.Title.Go_to_lobby'),
      children: /*#__PURE__*/_jsx(Icon, {
        iconKey: "video"
      })
    });
  };
  var callButtonProps = {
    phoneNumber: getCallableNumberFromContact(contact),
    extensionKey: extensionKey,
    transferContact: contact
  };
  return /*#__PURE__*/_jsxs("div", {
    className: twMerge('flex shrink-0 gap-x-2', className),
    children: [allowPresenceNotification ? /*#__PURE__*/_jsx(IconButton, {
      className: "size-10 rounded-sm bg-gray-200",
      onClick: handleTogglePresenceNotification,
      tooltipLabel: i18next.t('General.ExtensionBusyAlet.NotifyWhenAvailable'),
      children: shouldNotifyPresence ? /*#__PURE__*/_jsx(Icon, {
        iconKey: "notifications"
      }) : /*#__PURE__*/_jsx(Icon, {
        iconKey: "notificationsNoneIcon"
      })
    }) : null, emailAdress && /*#__PURE__*/_jsx(MailToWrapper, {
      recipient: emailAdress,
      children: /*#__PURE__*/_jsx(IconButton, {
        className: "size-10 rounded-sm bg-gray-200",
        tooltipLabel: i18next.t('Tooltip.Title.SendEmail'),
        children: /*#__PURE__*/_jsx(Icon, {
          iconKey: "email"
        })
      })
    }), chatUserKey && !disableMessaging && /*#__PURE__*/_jsx(IconButton, {
      className: "size-10 rounded-sm bg-gray-200",
      onClick: handleChatInteraction,
      tooltipLabel: i18next.t('Tooltip.Title.SendMessage'),
      children: /*#__PURE__*/_jsx(Icon, {
        iconKey: "chat"
      })
    }), /*#__PURE__*/_jsx(VideoButton, {}), /*#__PURE__*/_jsx(CallAdaptiveButton, _objectSpread(_objectSpread({}, callButtonProps), {}, {
      size: "medium",
      activeBg: true,
      bgColor: 'bg-gray-200'
    }))]
  });
};
SquareButtonsContainer.propTypes = {
  contact: PropTypes.instanceOf(Map),
  extensionKey: Flow.PropTypes.extensionKey,
  emailAdress: PropTypes.string,
  handleTogglePresenceNotification: PropTypes.func,
  shouldNotifyPresence: PropTypes.bool,
  allowPresenceNotification: PropTypes.bool,
  chatSessionKey: Flow.PropTypes.chatSessionKey,
  className: PropTypes.string,
  disableVideoCall: PropTypes.bool,
  disableMessaging: PropTypes.bool
};
export default SquareButtonsContainer;